import React from 'react';

import { Avatar, Box, Heading } from 'components';
import { Link } from 'core/routing';

interface CollaboratorsOverviewProps {
  collaborators: {
    username?: string;
    avatarUrl?: string;
    participantDisplayName?: string;
    imageFallbackChar: string;
    fullName: string;
    projects?: number;
    sharedFiles?: number;
  }[];
  className?: string;
}

export const CollaboratorsOverview = (props: CollaboratorsOverviewProps) => {
  const { collaborators, className } = props;

  return (
    <div className={`overflow-y-auto overflow-x-hidden ${className}`}>
      {collaborators.map((collaborator, index) => {
        const {
          username,
          avatarUrl,
          fullName,
          participantDisplayName,
          imageFallbackChar,
        } = collaborator;

        return (
          <div
            className={`flex items-center justify-between ${
              index === 0 ? '' : 'mt-4'
            }`}
            key={username}
            data-testid={`collaborator-row-${username}`}
          >
            <div className='flex'>
              <Link name='profile' params={{ profile: username }}>
                <Avatar
                  name={imageFallbackChar}
                  src={avatarUrl}
                  size='medium'
                />
              </Link>
              <Box
                ml={2}
                sx={{
                  flexDirection: 'column',
                  display: 'flex',
                  width: 164,
                }}
                style={{ flex: 1 }}
              >
                <Heading size='xsmall'>{fullName}</Heading>
                <span className='font-light text-xs text-black'>
                  {username || participantDisplayName}
                </span>
              </Box>
            </div>
          </div>
        );
      })}
    </div>
  );
};
